import type { IAgentResponse } from '@/features/agents/types/agent-types'
import { ONBOARDING_INTRO_PROMPT } from '@/features/onboarding/helpers/onboarding-constants'

type IDashboardRedirectAgent = Pick<IAgentResponse, 'uuid' | 'objective' | 'createdAt'>

interface IResolveDashboardAgentRedirectParams {
    agents: IDashboardRedirectAgent[]
    isOnboardingActive: boolean
    shouldOpenLatest: boolean
}

/** Selects the chat a dashboard arrival must open, with unfinished onboarding taking precedence. */
export function resolveDashboardAgentRedirect({
    agents,
    isOnboardingActive,
    shouldOpenLatest,
}: IResolveDashboardAgentRedirectParams) {
    if (agents.length === 0) return undefined

    if (isOnboardingActive) {
        return agents.reduce((oldest, agent) =>
            new Date(agent.createdAt) < new Date(oldest.createdAt) ? agent : oldest
        ).uuid
    }

    if (!shouldOpenLatest) return undefined

    return (agents.find((agent) => agent.objective !== ONBOARDING_INTRO_PROMPT) ?? agents[0]).uuid
}
